/* tslint:disable */
/* eslint-disable */
/**
 * Scality Guardian Backend
 *
 * The version of the OpenAPI document: 0.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Body for the options endpoint: the caller's current (staged) control selections.
 * @export
 * @interface DashboardOptionsRequest
 */
export interface DashboardOptionsRequest {
    /**
     * Staged selections keyed by control key; used to narrow cascades
     * @type {{ [key: string]: Array<string>; }}
     * @memberof DashboardOptionsRequest
     */
    selections?: { [key: string]: Array<string>; };
    /**
     * 
     * @type {string}
     * @memberof DashboardOptionsRequest
     */
    timeRange?: string | null;
}

/**
 * Check if a given object implements the DashboardOptionsRequest interface.
 */
export function instanceOfDashboardOptionsRequest(value: object): value is DashboardOptionsRequest {
    return true;
}

export function DashboardOptionsRequestFromJSON(json: any): DashboardOptionsRequest {
    return DashboardOptionsRequestFromJSONTyped(json, false);
}

export function DashboardOptionsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): DashboardOptionsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'selections': json['selections'] == null ? undefined : json['selections'],
        'timeRange': json['time_range'] == null ? undefined : json['time_range'],
    };
}

export function DashboardOptionsRequestToJSON(json: any): DashboardOptionsRequest {
    return DashboardOptionsRequestToJSONTyped(json, false);
}

export function DashboardOptionsRequestToJSONTyped(value?: DashboardOptionsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'selections': value['selections'],
        'time_range': value['timeRange'],
    };
}

